import React, { useContext, useEffect, useMemo } from 'react'
import SearchFormField from 'components/SearchV2/Components/SearchFormField/SearchFormField'
import { getBusinessTravellerSelectEnabled } from 'businessTraveller/utils/getBusinessTravellerSelectEnabled'
import { FlightSearchWidgetActions } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'
import { saveBusinessTravellerSelectedTravellerState } from 'businessTraveller/storage/businessTravellerStorage'
import FlightSearchWidgetDispatchContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetDispatchContext'
import setSelectedBusinessTravellersAndGuests from 'actions/businessTraveller/setSelectedBusinessTravellerEmployeesAndGuests'
import { clearFormStateSnapshot } from 'storage/checkout'
import { resetCheckoutForm } from 'actions/CheckoutActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { GlobalSearchDispatchContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'

interface Props {
  className?: string;
  label?: string;
  value?: string;
}

function BusinessTravellerSelectDisabled(props: Props) {
  const { className, label, value } = props

  const globalSearchDispatch = useContext(GlobalSearchDispatchContext)
  const flightsDispatch = useContext(FlightSearchWidgetDispatchContext)
  const appDispatch = useAppDispatch()
  const approvalRequestId = useAppSelector(state => state.checkout.cart.approvalRequestId)
  const businessAccount = useAppSelector(state => state.businessTraveller.currentBusinessAccount)

  const employeeName = useMemo(() => {
    if (!businessAccount?.employee?.id) {
      return undefined
    }
    return `${businessAccount.employee.firstName} ${businessAccount.employee.lastName}`
  }, [businessAccount?.employee])

  useEffect(() => {
    // Set a default traveller, only for users that are travellers, not admins or managers (OPERX-263)
    const businessTravellerSelectEnabled = getBusinessTravellerSelectEnabled(businessAccount)
    if (!businessTravellerSelectEnabled && businessAccount?.employee?.id && !approvalRequestId) {
      // Ensure flight state matches selected traveller state
      const occupants: App.Occupants = {
        adults: 1,
        children: 0,
        infants: 0,
        childrenAge: [],
      }
      flightsDispatch({ type: FlightSearchWidgetActions.SET_OCCUPANTS, occupants })
      // Ensure hotel state matches selected traveller state
      globalSearchDispatch({ type: GlobalSearchStateActions.SET_OCCUPANCIES, occupancies: [occupants] })
      // Reset checkout form
      appDispatch(resetCheckoutForm())
      clearFormStateSnapshot()
      // Update employee list and guest count in redux state
      appDispatch(setSelectedBusinessTravellersAndGuests([businessAccount.employee.id], 0))
      saveBusinessTravellerSelectedTravellerState([businessAccount.employee.id])
    }
  }, [flightsDispatch, appDispatch, globalSearchDispatch, businessAccount, approvalRequestId])

  return (<SearchFormField
    className={className}
    label={label ?? 'Travellers'}
    value={value ?? employeeName ?? '1 Traveller'}
    disabled
  />)
}

export default BusinessTravellerSelectDisabled
